module.exports = __webpack_public_path__ + "static/media/hair7.e4032014.png";